export default __webpack_public_path__ + "img/edit.aa0cfcbc.svg";